import styled, { createGlobalStyle } from 'styled-components';

const CountryPhoneContainer = styled.div `
  ${props => props.isMobile &&
    `
    .ant-select-arrow {
      margin-top: 0;
    }
  `}

  .international-phone-field {
    .ant-select-selector {
      /* prettier-ignore */
      min-width: 76.8Px !important;
      padding-left: 0 !important;
      border: none !important;
    }

    .ant-select-selection-item {
      color: var(--black) !important;
      display: flex;
      align-items: center;
    }

    .ant-select {
      background: transparent !important;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      position: relative;
      // prettier-ignore
      padding-left: 8Px;

      * {
        background: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
      }
    }

    .antd-country-phone-input {
      .ant-input-group-addon {
        background: white !important;
        border-right: none !important;
      }
    }

    &.small {
      .ant-input-affix-wrapper {
        /* prettier-ignore */
        height: 32Px;
      }

      .ant-input {
        /* prettier-ignore */
        height: 32Px;
      }

      .ant-select {
        .ant-select-selection-search {
          left: 0px !important;
        }
      }
    }

    &.large {
      .ant-input {
        /* prettier-ignore */
        height: 44Px;
      }
    }

    &.middle {
      .ant-input {
        /* prettier-ignore */
        height: 38Px;
      }
    }
  }
`;
const MobileInputStyle = createGlobalStyle `
  .ant-input {
    font-size: var(--font-size-xl);
  }
  .ant-select-selection-item{
    font-size: var(--font-size-xl);
  }
 
  .ant-select-item-option-content{
    font-size: var(--font-size-xl);
  }
  .ant-select-arrow{
    font-size: var(--font-size-lg);
  }
  .ant-form-item-explain{
    font-size: var(--font-size-xl);
  }
`;

export { CountryPhoneContainer, MobileInputStyle };
